import Vue from 'vue'
import Vuex from 'vuex'
import Router from 'vue-router'
import Vuetify from 'vuetify'

import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import notification from './modules/notification'
import filters from './modules/filters'
import toggles from './modules/toggles'
import auth from './modules/auth'
import localStoragePlugin from './plugins/localStorage'

Vue.use(Vuex)
Vue.use(Router)
Vue.use(Vuetify)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  state: {
    countries: [],
    selectedCountries: [],
    states: [],
    selectedStates: [],
    cities: [],
    selectedCities: [],
    languages: [],
    selectedLanguages: [],
    countryMap: {
      'Afghanistan': 'Afghanistan',
      'Åland Islands': 'Aland',
      'Albania': 'Albania',
      'Algeria': 'Algeria',
      'American Samoa': 'American Samoa',
      'Andorra': 'Andorra',
      'Angola': 'Angola',
      'Anguilla': 'Anguilla',
      'Antarctica': 'Antarctica',
      'Antigua and Barbuda': 'Antigua and Barb.',
      'Argentina': 'Argentina',
      'Armenia': 'Armenia',
      'Aruba': 'Aruba',
      'Australia': 'Australia',
      'Austria': 'Austria',
      'Azerbaijan': 'Azerbaijan',
      'Bahamas': 'Bahamas',
      'Bahrain': 'Bahrain',
      'Bangladesh': 'Bangladesh',
      'Barbados': 'Barbados',
      'Belarus': 'Belarus',
      'Belgium': 'Belgium',
      'Belize': 'Belize',
      'Benin': 'Benin',
      'Bermuda': 'Bermuda',
      'Bhutan': 'Bhutan',
      'Bolivia, Plurinational State of': 'Bolivia',
      'Bosnia and Herzegovina': 'Bosnia and Herz.',
      'Botswana': 'Botswana',
      'Brazil': 'Brazil',
      'British Indian Ocean Territory': 'Br. Indian Ocean Ter.',
      'Brunei Darussalam': 'Brunei',
      'Bulgaria': 'Bulgaria',
      'Burkina Faso': 'Burkina Faso',
      'Burundi': 'Burundi',
      'Cambodia': 'Cambodia',
      'Cameroon': 'Cameroon',
      'Canada': 'Canada',
      'Cape Verde': 'Cape Verde',
      'Cayman Islands': 'Cayman Is.',
      'Central African Republic': 'Central African Rep.',
      'Chad': 'Chad',
      'Chile': 'Chile',
      'China': 'China',
      'Christmas Island': 'Christmas Island',
      'Cocos (Keeling) Islands': 'Cocos (Keeling) Is.',
      'Colombia': 'Colombia',
      'Comoros': 'Comoros',
      'Congo': 'Congo',
      'Congo, the Democratic Republic of the': 'Dem. Rep. Congo',
      'Cook Islands': 'Cook Is.',
      'Costa Rica': 'Costa Rica',
      'Côte d’Ivoire': 'Côte d\'Ivoire',
      'Croatia': 'Croatia',
      'Cuba': 'Cuba',
      'Curaçao': 'Curaçao',
      'Cyprus': 'Cyprus',
      'Czech Republic': 'Czech Rep.',
      'Denmark': 'Denmark',
      'Djibouti': 'Djibouti',
      'Dominica': 'Dominica',
      'Dominican Republic': 'Dominican Rep.',
      'Ecuador': 'Ecuador',
      'Egypt': 'Egypt',
      'El Salvador': 'El Salvador',
      'Equatorial Guinea': 'Eq. Guinea',
      'Eritrea': 'Eritrea',
      'Estonia': 'Estonia',
      'Ethiopia': 'Ethiopia',
      'Falkland Islands (Malvinas)': 'Falkland Is.',
      'Faroe Islands': 'Faeroe Is.',
      'Fiji': 'Fiji',
      'Finland': 'Finland',
      'France': 'France',
      'French Guiana': 'French Guiana',
      'French Polynesia': 'French Polynesia',
      'Gabon': 'Gabon',
      'Gambia': 'Gambia',
      'Georgia': 'Georgia',
      'Germany': 'Germany',
      'Ghana': 'Ghana',
      'Gibraltar': 'Gibraltar',
      'Greece': 'Greece',
      'Greenland': 'Greenland',
      'Grenada': 'Grenada',
      'Guadeloupe': 'Guadeloupe',
      'Guam': 'Guam',
      'Guatemala': 'Guatemala',
      'Guernsey': 'Guernsey',
      'Guinea': 'Guinea',
      'Guinea-Bissau': 'Guinea-Bissau',
      'Guyana': 'Guyana',
      'Haiti': 'Haiti',
      'Holy See (Vatican City State)': 'Holy See (Vatican City State)',
      'Honduras': 'Honduras',
      'Hungary': 'Hungary',
      'Iceland': 'Iceland',
      'India': 'India',
      'Indonesia': 'Indonesia',
      'Iran, Islamic Republic of': 'Iran',
      'Iraq': 'Iraq',
      'Ireland': 'Ireland',
      'Isle of Man': 'Isle of Man',
      'Israel, State of': 'Israel',
      'Italy': 'Italy',
      'Jamaica': 'Jamaica',
      'Japan': 'Japan',
      'Jersey': 'Jersey',
      'Jordan': 'Jordan',
      'Kazakhstan': 'Kazakhstan',
      'Kenya': 'Kenya',
      'Kiribati': 'Kiribati',
      'Korea, Democratic People\'s Republic of (North)': 'Dem. Rep. Korea',
      'Korea, Republic of (South)': 'Korea',
      'Kuwait': 'Kuwait',
      'Kosovo': 'Kosovo',
      'Kyrgyzstan': 'Kyrgyzstan',
      'Lao People\'s Democratic Republic (Laos)': 'Lao PDR',
      'Latvia': 'Latvia',
      'Lebanon': 'Lebanon',
      'Lesotho': 'Lesotho',
      'Liberia': 'Liberia',
      'Libya': 'Libya',
      'Liechtenstein': 'Liechtenstein',
      'Lithuania': 'Lithuania',
      'Luxembourg': 'Luxembourg',
      'Macau': 'Macau',
      'Macedonia, Republic of': 'Macedonia',
      'Madagascar': 'Madagascar',
      'Malawi': 'Malawi',
      'Malaysia': 'Malaysia',
      'Maldives': 'Maldives',
      'Mali': 'Mali',
      'Malta': 'Malta',
      'Marshall Islands': 'Marshall Is.',
      'Martinique': 'Martinique',
      'Mauritania': 'Mauritania',
      'Mauritius': 'Mauritius',
      'Mayotte': 'Mayotte',
      'Mexico': 'Mexico',
      'Micronesia, Federated States of': 'Micronesia, Federated States of',
      'Moldova, Republic of': 'Moldova',
      'Monaco': 'Monaco',
      'Mongolia': 'Mongolia',
      'Montenegro': 'Montenegro',
      'Montserrat': 'Montserrat',
      'Morocco': 'Morocco',
      'Mozambique': 'Mozambique',
      'Myanmar': 'Myanmar',
      'Namibia': 'Namibia',
      'Nauru': 'Nauru',
      'Nepal': 'Nepal',
      'Netherlands': 'Netherlands',
      'New Caledonia': 'New Caledonia',
      'New Zealand': 'New Zealand',
      'Nicaragua': 'Nicaragua',
      'Niger': 'Niger',
      'Nigeria': 'Nigeria',
      'Niue': 'Niue',
      'Norfolk Island': 'Norfolk Island',
      'Northern Mariana Islands': 'N. Mariana Is.',
      'Norway': 'Norway',
      'Oman': 'Oman',
      'Pakistan': 'Pakistan',
      'Palau': 'Palau',
      'Palestinian, State of': 'Palestine',
      'Panama': 'Panama',
      'Papua New Guinea': 'Papua New Guinea',
      'Paraguay': 'Paraguay',
      'Peru': 'Peru',
      'Philippines': 'Philippines',
      'Pitcairn': 'Pitcairn',
      'Poland': 'Poland',
      'Portugal': 'Portugal',
      'Puerto Rico': 'Puerto Rico',
      'Qatar': 'Qatar',
      'Réunion': 'Réunion',
      'Romania': 'Romania',
      'Russia': 'Russia',
      'Rwanda': 'Rwanda',
      'Saint Barthélemy': 'St. Barthélemy',
      'Saint Helena, Ascension and Tristan da Cunha': 'St. Helena, Ascension and Tristan da Cunha',
      'Saint Kitts and Nevis': 'St. Kitts and Nevis',
      'Saint Lucia': 'Saint Lucia',
      'Saint Martin, Collectivity of': 'St. Martin, Collectivity of',
      'Saint Pierre and Miquelon': 'St. Pierre and Miquelon',
      'Saint Vincent and the Grenadines': 'St. Vin. and Gren.',
      'Samoa': 'Samoa',
      'San Marino': 'San Marino',
      'Sao Tome and Principe': 'São Tomé and Principe',
      'Saudi Arabia': 'Saudi Arabia',
      'Senegal': 'Senegal',
      'Serbia': 'Serbia',
      'Seychelles': 'Seychelles',
      'Sierra Leone': 'Sierra Leone',
      'Singapore': 'Singapore',
      'Sint Maarten': 'Sint Maarten',
      'Slovakia': 'Slovakia',
      'Slovenia': 'Slovenia',
      'Solomon Islands': 'Solomon Is.',
      'Somalia': 'Somalia',
      'South Africa': 'South Africa',
      'South Georgia and the South Sandwich Islands': 'S. Geo. and S. Sandw. Is.',
      'Spain': 'Spain',
      'Sri Lanka': 'Sri Lanka',
      'Sudan': 'Sudan',
      'South Sudan': 'S. Sudan',
      'Suriname': 'Suriname',
      'Svalbard and Jan Mayen': 'Svalbard and Jan Mayen',
      'Swaziland': 'Swaziland',
      'Sweden': 'Sweden',
      'Switzerland': 'Switzerland',
      'Syrian Arab Republic': 'Syria',
      'Taiwan, Province of China': 'Taiwan',
      'Tajikistan': 'Tajikistan',
      'Tanzania, United Republic of': 'Tanzania',
      'Thailand': 'Thailand',
      'Timor-Leste': 'Timor-Leste',
      'Togo': 'Togo',
      'Tokelau': 'Tokelau',
      'Tonga': 'Tonga',
      'Trinidad and Tobago': 'Trinidad and Tobago',
      'Tunisia': 'Tunisia',
      'Turkey': 'Turkey',
      'Turkmenistan': 'Turkmenistan',
      'Turks and Caicos Islands': 'Turks and Caicos Is.',
      'Tuvalu': 'Tuvalu',
      'Uganda': 'Uganda',
      'Ukraine': 'Ukraine',
      'United Arab Emirates': 'United Arab Emirates',
      'United Kingdom': 'United Kingdom',
      'United States of America': 'United States',
      'United States Minor Outlying Islands': 'United States Minor Outlying Is.',
      'Uruguay': 'Uruguay',
      'Uzbekistan': 'Uzbekistan',
      'Vanuatu': 'Vanuatu',
      'Venezuela, Bolivarian Republic of': 'Venezuela',
      'Vietnam, Socialist Republic of': 'Vietnam',
      'Virgin Islands, British': 'Virgin Islands, British',
      'Virgin Islands, United States': 'U.S. Virgin Is.',
      'Wallis and Futuna': 'Wallis and Futuna',
      'Western Sahara': 'W. Sahara',
      'Yemen': 'Yemen',
      'Zambia': 'Zambia',
      'Zimbabwe': 'Zimbabwe'
    }
  },
  actions,
  getters,
  mutations,
  modules: { notification, auth, filters, toggles },
  plugins: [localStoragePlugin],
  strict: debug
})



// WEBPACK FOOTER //
// ./src/store/index.js